import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MessageBoxParameter } from '@classes/message-box-parameter';
import { SitePicture } from '@classes/site-picture';
import { MessageBox } from '@components/message-box/message-box.component';
import { Role } from '@enums/role.enum';
import { TranslateService } from '@ngx-translate/core';
import { SiteService } from 'app/core/services/site.service';
import { UiService } from 'app/core/services/ui.service';

@Component({
  selector: 'app-site-picture',
  templateUrl: './site-picture.component.html',
  styleUrls: ['./site-picture.component.scss']
})
export class SitePictureComponent implements OnInit {

  Role = Role;

  constructor(
    public siteService: SiteService,
    public uiService: UiService,
    public dialog: MatDialog,
    public translateService: TranslateService,
    public dialogRef: MatDialogRef<SitePictureComponent>,
    @Inject(MAT_DIALOG_DATA) public data?: SitePicture
  ) { }

  ngOnInit() {
  }

  onDeletePicture() {
    const messageBoxParameter = new MessageBoxParameter();

    messageBoxParameter.message = this.translateService.instant('site-picture.confirm-delete');
    messageBoxParameter.dialog = this.dialog;
    messageBoxParameter.title = 'Confirmation';
    messageBoxParameter.buttons = ['yes', 'no'];
    messageBoxParameter.width = "400px";

    MessageBox.show(messageBoxParameter).subscribe(mbResult => {
      if (mbResult && mbResult.value) {
        this.uiService.addRouteLoading();
        this.siteService.deletePicture(this.data?.id || "").subscribe(data => {
          this.uiService.displayMessageToast(this.translateService.instant('site-picture.success-delete'));
          this.dialogRef.close(true);
        }, error => {
          console.error(error);
        }, () => {
          this.uiService.removeRouteLoading();
        });
      }
    });
  }
}
